import MonitoringController from './monitoring.controller';

export default {
    template: require('./monitoring.html'),
    controller: MonitoringController
};
